export { default as Img200 } from './processed/200/LesMiserables_Horiz.jpg';
export { default as Img400 } from './processed/400/LesMiserables_Horiz.jpg';
export { default as Imgthumb } from './processed/thumb/LesMiserables_Horiz.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/LesMiserables_Horiz.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/LesMiserables_Horiz.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      199,
      41,
      35
    ],
    "_population": 488,
    "_hsl": [
      0.006097560975609757,
      0.7008547008547007,
      0.45882352941176474
    ]
  },
  "LightVibrant": {
    "_rgb": [
      221,
      183,
      165
    ],
    "_population": 244,
    "_hsl": [
      0.05357142857142855,
      0.4516129032258065,
      0.7568627450980392
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      6,
      31,
      46
    ],
    "_population": 1092,
    "_hsl": [
      0.5625,
      0.7692307692307693,
      0.10196078431372549
    ]
  },
  "Muted": {
    "_rgb": [
      149,
      106,
      87
    ],
    "_population": 461,
    "_hsl": [
      0.051075268817204304,
      0.2627118644067797,
      0.4627450980392157
    ]
  },
  "LightMuted": {
    "_rgb": [
      206,
      188,
      170
    ],
    "_population": 339,
    "_hsl": [
      0.08333333333333341,
      0.26865671641791056,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      41,
      73,
      86
    ],
    "_population": 571,
    "_hsl": [
      0.5481481481481482,
      0.35433070866141736,
      0.24901960784313726
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/LesMiserables_Horiz.js